import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { ActionsIcon } from '../../../../../../assets/svg/actions';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { InfiniteScroll } from '../../../../../../components/infinite-scroll/infinite-scroll';
import { Tooltip } from '../../../../../../features/tooltip/tooltip';
import { formatRuDateTimeString } from '../../../../../../helpers/date-time';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import s from './branches-cards.module.css';

export const BranchesCards = () => {
  const { place, isLoadingFetch } = useBranchesStore();

  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();

  const editBranchModal = useModalParams('editBranch');
  const archiveBranchModal = useModalParams('archiveBranch');

  if (!place?.length && !isLoadingFetch) {
    return <div>{t('Здесь пока нет филиалов')}</div>;
  }

  return (
    <ul className={s.feature}>
      {place?.map((item) => {
        return (
          <li key={item.id} className={s.item}>
            <div className={s.top}>
              <span>
                <div className={s.title}>{t('Создано')}</div>
                <div className={s.subtitle}>{formatRuDateTimeString(item.created_at)}</div>
              </span>

              {item.is_deleted ? (
                <IconButton
                  tooltip={t('Восстановить')}
                  variant="secondary"
                  size="sm"
                  onClick={() =>
                    addQueryParams({
                      restoreId: String(item.id),
                      restoreName: getLocale(item.name),
                    })
                  }
                >
                  <TbRestore />
                </IconButton>
              ) : (
                <Tooltip
                  triggerWrapperClassName={s.actionsButton}
                  optionsWrapperClassName={s.actions}
                  trigger={<ActionsIcon />}
                  offset={12}
                >
                  <div className={s.actions}>
                    <IconButton
                      tooltip={t('Редактировать')}
                      size="sm"
                      variant="secondary"
                      onClick={() => editBranchModal.handleOpenModal({ branchId: item.id })}
                    >
                      <AiOutlineEdit />
                    </IconButton>

                    <IconButton
                      tooltip={t('Удалить')}
                      size="sm"
                      variant="secondary"
                      onClick={() =>
                        archiveBranchModal.handleOpenModal({
                          branchId: item.id,
                          branchName: getLocale(item.name),
                        })
                      }
                    >
                      <AiOutlineDelete />
                    </IconButton>
                  </div>
                </Tooltip>
              )}
            </div>

            <div className={s.main}>
              <span>
                <span className={s.title} style={{ marginRight: 17 }}>
                  {getLocale(item.address)}
                </span>

                <span className={s.subtitle}>
                  {item.staff_count === 0
                    ? `0 ${t('сотрудник_zero')}`
                    : `${item.staff_count} ${t('сотрудник', { count: Number(item.staff_count) })}`}
                </span>
              </span>

              <div className={s.name}>
                {t('Филиал')} {getLocale(item.name)}
              </div>
            </div>

            <div>
              <div className={s.title}>{t('Номер телефона')}</div>
              <div className={s.subtitle}>{item.phone}</div>
            </div>
          </li>
        );
      })}

      <InfiniteScroll onEnterView={() => {}} />
    </ul>
  );
};
